/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { bindActionCreators } from 'redux';
import CustomInputField from './Partials/CustomInputField/CustomInputField';
import CustomSelectField from './Partials/CustomSelectField/CustomSelectField';

import TypeChecking from './TypeChecking';
import ValidationRules from './ValidationRules';
import * as commonSelectors from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import MaskInput from './MaskInput';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    inputBoldLabel: {
        fontSize: '11.0px',
        '@media screen and (min-width: 601px)': {
            fontSize: '13.5px',
        },
        top: '4px',
        color: theme.palette.black,
        fontWeight: '600',
        minWidth: '100px',
        zIndex: '4',
    },
    borderedInput: {
        borderTop: '1px solid rgba(0,0,0,0.42)',
        borderLeft: '1px solid rgba(0,0,0,0.42)',
        borderRight: '1px solid rgba(0,0,0,0.42)',
        boxSizing: 'border-box',
        paddingLeft: '10px',
        minHeight: '2em',
    },
    borderedSelect: {
        borderTop: '1px solid rgba(0,0,0,0.42)',
        borderLeft: '1px solid rgba(0,0,0,0.42)',
        borderRight: '1px solid rgba(0,0,0,0.42)',
        boxSizing: 'border-box',
        paddingLeft: '10px',
        marginTop: '0',
    },
    nativeSelect: {
        borderTop: '1px solid rgba(0,0,0,0.42)',
        borderLeft: '1px solid rgba(0,0,0,0.42)',
        borderRight: '1px solid rgba(0,0,0,0.42)',
        boxSizing: 'border-box',
        paddingLeft: '10px',
        marginTop: '0',
        '&:focus': {
            backgroundColor: theme.palette.white,
        },
    },
    helperText: {
        color: 'red',
        minHeight: 'auto',
    },
});

class TextFieldWrapper extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            displayFieldInfo: false,
        };
        const { id, name } = this.props;
        this.fieldId = id || name;
        this.returnFieldState = null;
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
    }

    componentDidMount() {
        const { returnFieldProps } = this.props;
        if (returnFieldProps) {
            returnFieldProps(this.returnProps);
        }
    }

    handleChange(event) {
        const {
            inputType, max, setTextInputState, maskInput,
        } = this.props;
        const fieldName = event.target.name;
        this.removePjsErrors(fieldName);
        this.removePjsErrors(event.target.id);
        const validateAider = {
            ...this.props,
            value: event.target.value,
        };

        const restrictInput = TypeChecking[inputType];
        let allow = false;
        let inputVal = '';

        if (restrictInput) {
            inputVal = (restrictInput) ? restrictInput(validateAider) : validateAider.value;
            if (inputVal === validateAider.value) {
                allow = true;
            }

            if (max && allow) {
                if (inputVal.length > max) {
                    inputVal = event.target.value.substring(0, max);
                }
            }
        } else {
            allow = true;
            inputVal = event.target.value;
        }

        if (maskInput) {
            const maskInputFun = MaskInput[maskInput];
            const resMaskInput = maskInputFun(inputVal, this.props, event);
            if (resMaskInput) {
                const { allow: allowUpdate, maskInputVal } = resMaskInput;
                allow = allowUpdate;
                inputVal = maskInputVal;
                this.returnFieldState = !this.returnFieldState;
            }
        }

        if (allow) {
            validateAider.value = inputVal;
            const validationResponse = this.validateField(validateAider, fieldName, true);
            const data = {
                target: {
                    name: event.target.name,
                    value: inputVal,
                },
            };
            const nextFieldState = (validationResponse.alert) ? validationResponse.alert : validationResponse.flagError;
            if (this.returnFieldState !== nextFieldState) {
                setTextInputState(data, validationResponse);
                this.returnFieldState = nextFieldState;
            } else {
                setTextInputState(data, null);
            }
        }
    }

    handleBlur(event) {
        const { isInputFilled } = this.props;
        const fieldName = event.target.name;
        this.removePjsErrors(fieldName);
        this.removePjsErrors(event.target.id);
        const validateAider = {
            ...this.props,
            value: event.target.value,
        };
        const validationResponse = this.validateField(validateAider, fieldName, false);
        isInputFilled(fieldName, validationResponse);
    }

    handleOnFocus(event) {
        const { handleOnFocus } = this.props;
        this.returnFieldState = null;
        handleOnFocus(event);
    }

    handleOnKeyUp(event) {
        const { handleOnKeyUp } = this.props;
        handleOnKeyUp(event);
    }

    returnProps = () => this.props;

    toggleDisplayFieldInfo = () => {
        const { displayFieldInfo } = this.state;
        this.setState({
            displayFieldInfo: !displayFieldInfo,
        });
    }

    getTextField = () => {
        const {
            classes, getBrand, silent, required, select,
            autoComplete, label, name, val, errorMessage,
            flagError, className, inputProps, /* InputProps, */ variant, disabled,
            dropdown, textarea, placeholder, rows, borderedSelect, borderedInput,
            inputType, max, nativeSelect, infoHelpText, customInput, customSelect,
            inputFieldType, showIntputBox, showDefaultDropDownValue, startAdornment, track,
            redAsterisk,

        } = this.props;
        const { displayFieldInfo } = this.state;
        const raisedBrands = ['HD', 'SY', 'WLF'];
        const isRaisedBrand = raisedBrands.includes(getBrand.code);
        const isRequired = (silent) ? false : required;

        if (select) {
            /* Select Box */
            return (
                <TextField
                    select
                    // autoComplete="off"
                    // autoComplete="on"
                    autoComplete={autoComplete}
                    required={isRequired}
                    label={label}
                    placeholder={placeholder}
                    id={this.fieldId}
                    key={`tf_input_${this.fieldId}`}
                    name={name}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleOnFocus}
                    value={val}
                    helperText={errorMessage}
                    error={flagError}
                    className={className}
                    fullWidth
                    inputProps={{
                        'data-test': `checkout-text-field-${name}`,  // do NOT change or remove data-test attribute
                        ...inputProps,
                    }}
                    // InputProps={InputProps}
                    variant={variant}
                    disabled={disabled}
                >
                    {dropdown}
                </TextField>
            );
        } if (textarea) {
            /* Textarea */
            return (
                <TextField
                    fullWidth
                    multiline
                    // autoComplete="off"
                    // autoComplete="on"
                    autoComplete={autoComplete}
                    variant={variant}
                    required={isRequired}
                    label={label}
                    placeholder={placeholder}
                    name={name}
                    id={this.fieldId}
                    key={`tf_input_${this.fieldId}`}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleOnFocus}
                    onKeyUp={this.handleOnKeyUp}
                    value={val}
                    helperText={errorMessage}
                    error={flagError}
                    rows={rows}
                    className={className}
                    inputProps={{
                        'data-test': `checkout-text-field-${name}`,  // do NOT change or remove data-test attribute
                        'data-testid': `datatestid-checkout-field-${name}`,  // do NOT change or remove unit test need
                        maxLength: max || null,
                        ...inputProps,
                    }}
                    // InputProps={InputProps}
                    disabled={disabled}
                />
            );
        } if (borderedSelect) {
            /* Select Box styled with border */
            return (
                <Fragment key={`div_input_${this.fieldId}`}>
                    <InputLabel
                        key={`il_input_${this.fieldId}`}
                        shrink
                        htmlFor={name}
                        className={classes.inputBoldLabel}
                        required={isRequired}
                        data-test={`checkout-text-label-${name}`}
                    >
                        {label}
                    </InputLabel>
                    <TextField
                        // autoComplete="off"
                        // autoComplete="on"
                        autoComplete={autoComplete}
                        select
                        required={isRequired}
                        name={name}
                        placeholder={placeholder}
                        id={this.fieldId}
                        key={`tf_input_${this.fieldId}`}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleOnFocus}
                        value={val}
                        helperText={errorMessage}
                        error={flagError}
                        className={className}
                        fullWidth
                        inputProps={{
                            className: !isRaisedBrand ? classes.borderedSelect : null,
                            'data-test': `checkout-text-field-${name}`,              // do NOT change or remove data-test attribute
                        }}
                        data-test={`checkout-text-field-div-wrapper-${name}`}
                        // InputProps={InputProps}
                        disabled={disabled}
                    >
                        {dropdown}
                    </TextField>
                </Fragment>
            );
        } if (borderedInput) {
            /* Text Box styled with border */
            return (
                <Fragment key={`div_input_${this.fieldId}`}>
                    <InputLabel
                        key={`il_input_${this.fieldId}`}
                        shrink
                        htmlFor={name}
                        className={classes.inputBoldLabel}
                        required={isRequired}
                        data-test={`checkout-text-label-${name}`}    // do NOT change or remove data-test attribute
                    >
                        {label}
                    </InputLabel>
                    <TextField
                        type={inputType}
                        // autoComplete="off"
                        // autoComplete="on"
                        autoComplete={autoComplete}
                        placeholder={placeholder}
                        fullWidth
                        required={isRequired}
                        name={name}
                        key={`tf_input_${this.fieldId}`}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleOnFocus}
                        onKeyUp={this.handleOnKeyUp}
                        value={val}
                        id={this.fieldId}
                        helperText={errorMessage}
                        error={flagError}
                        rows={rows}
                        inputProps={{
                            className: !isRaisedBrand ? classes.borderedInput : null,
                            maxLength: max || null,
                            'data-test': `checkout-text-field-${name}`,              // do NOT change or remove data-test attribute
                        }}
                        // InputProps={InputProps}
                        disabled={disabled}
                    />
                </Fragment>
            );
        } if (nativeSelect) {
            const options = dropdown.map((element, index) => {
                const optionKey = `dropdownItem${index}`;
                return (
                    <option
                        key={optionKey}
                        value={element.props.value}
                        data-test={`checkout-select-option-${element.props.value}`}
                    >
                        {element.props.children}
                    </option>
                );
            });

            return (
                <Fragment key={`div_input_${this.fieldId}`}>
                    <InputLabel
                        ref={(ref) => {
                            this.InputLabelRef = ref;
                        }}
                        key={`il_input_${this.fieldId}`}
                        shrink
                        htmlFor={name}
                        className={classes.inputBoldLabel}
                        required={isRequired}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        native
                        className={!isRaisedBrand ? classes.nativeSelect : null}
                        // autoComplete="off"
                        // autoComplete="on"
                        autoComplete={autoComplete}
                        required={isRequired}
                        name={name}
                        placeholder={placeholder}
                        id={this.fieldId}
                        key={`tf_input_${this.fieldId}`}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleOnFocus}
                        value={val}
                        error={flagError}
                        fullWidth
                        disabled={disabled}
                        SelectDisplayProps={{
                            'data-test': `checkout-select-field-div-wrapper-${name}`,    // do NOT change or remove data-test attribute
                        }}
                        inputProps={{
                            'data-test': `checkout-select-field-${name}`,    // do NOT change or remove data-test attribute
                            ...inputProps,
                        }}
                    >
                        {options}
                    </Select>
                    <FormHelperText className={classes.helperText}>{errorMessage}</FormHelperText>
                </Fragment>
            );
        } if (customInput) {
            return (
                <CustomInputField
                    // Please dont sent {...this.props} //sent the properties you need ...this.props get like 60 warning errors in console
                    inputFieldType={inputFieldType}
                    key={`customInputF${name}`}
                    name={name}
                    label={label}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    val={val}
                    flagError={flagError}
                    errorMessage={errorMessage}
                    infoHelpText={infoHelpText}
                    // InputProps={InputProps}
                    disabled={disabled}
                    fieldId={this.fieldId}
                    isRequired={isRequired}
                    handleChange={this.handleChange}
                    handleBlur={this.handleBlur}
                    handleOnFocus={this.handleOnFocus}
                    handleOnKeyUp={this.handleOnKeyUp}
                    toggleDisplayFieldInfo={this.toggleDisplayFieldInfo}
                    showInfo={displayFieldInfo}
                    startAdornment={startAdornment}
                    track={track}
                    redAsterisk={redAsterisk}
                />
            );
        } if (customSelect) {
            return (
                <div key={`customSelect${name}`}>
                    <CustomSelectField
                        key={`customSelectF${name}`}
                        name={name}
                        label={label}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        val={(!showIntputBox) ? val : showDefaultDropDownValue}
                        flagError={flagError}
                        errorMessage={errorMessage}
                        infoHelpText={infoHelpText}
                        disabled={disabled}
                        dropdown={dropdown}
                        fieldId={this.fieldId}
                        isRequired={isRequired}
                        handleChange={this.handleChange}
                        handleBlur={this.handleBlur}
                        handleOnFocus={this.handleOnFocus}
                        handleOnKeyUp={this.handleOnKeyUp}
                        toggleDisplayFieldInfo={this.toggleDisplayFieldInfo}
                        showInfo={displayFieldInfo}
                        showIntputBox={showIntputBox}
                        track={track}
                        redAsterisk={redAsterisk}
                    />
                    {(showIntputBox)
                        ? (
                            <CustomInputField
                                // Please dont sent {...this.props} //sent the properties you need ...this.props get like 60 warning errors in console
                                key={`customInput${name}`}
                                name={name}
                                label={label}
                                placeholder={placeholder}
                                autoComplete={autoComplete}
                                val={val}
                                inputFieldType={inputFieldType}
                                flagError={flagError}
                                errorMessage={errorMessage}
                                infoHelpText={infoHelpText}
                                inputProps={{
                                    'data-test': `checkout-text-field-${name}`,  // do NOT change or remove data-test attribute
                                    ...inputProps,
                                }}
                                disabled={disabled}
                                fieldId={this.fieldId}
                                isRequired={isRequired}
                                handleChange={this.handleChange}
                                handleBlur={this.handleBlur}
                                handleOnFocus={this.handleOnFocus}
                                handleOnKeyUp={this.handleOnKeyUp}
                                toggleDisplayFieldInfo={this.toggleDisplayFieldInfo}
                                showInfo={displayFieldInfo}
                                showIntputBox={showIntputBox}
                                startAdornment={startAdornment}
                                track={track}
                                redAsterisk={redAsterisk}
                            />
                        ) : null}
                </div>
            );
        }
        /* Text Box */
        return (
            <TextField
                type={inputFieldType}
                key={`tf_input_${this.fieldId}`}
                // autoComplete="off"
                // autoComplete="on"
                autoComplete={autoComplete}
                fullWidth
                required={isRequired}
                label={label}
                placeholder={placeholder}
                name={name}
                id={this.fieldId}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onFocus={this.handleOnFocus}
                onKeyUp={this.handleOnKeyUp}
                value={val}
                helperText={errorMessage}
                error={flagError}
                className={className}
                variant={variant}
                // InputProps={InputProps}
                // inputProps={inputProps}
                disabled={disabled}
                inputProps={{
                    'data-test': `checkout-text-field-${name}`,    // do NOT change or remove data-test attribute
                }}
            />
        );
    }

    validateField = (validateAider, fieldName, skipOnChangeValidation) => {
        const { validateRule } = this.props;
        if (Object.prototype.hasOwnProperty.call(ValidationRules, validateRule)) {
            const validatorFunction = ValidationRules[validateRule];
            const validate = validatorFunction(validateAider, skipOnChangeValidation);
            return validate;
        }
        const validate = ValidationRules.Mandatory(validateAider);
        return validate;
    }

    removePjsErrors = (className) => document.querySelectorAll(`${'.'}${className}${'-pjs-error'}`).forEach((el) => el.remove());

    render() {
        return [
            this.getTextField(),
        ];
    }
}

const mapStateToProps = (state) => ({
    getBrand: commonSelectors.getBrand(state),
});

const mapDispatchToProps = (dispatch) => ({
    track: bindActionCreators(trackEvent, dispatch),
});

TextFieldWrapper.propTypes = {
    id: PropTypes.string,
    val: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    select: PropTypes.bool,
    borderedSelect: PropTypes.bool,
    borderedInput: PropTypes.bool,
    textarea: PropTypes.bool,
    inputFieldType: PropTypes.string,
    classes: PropTypes.object.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    infoHelpText: PropTypes.string,
    className: PropTypes.string,
    dropdown: PropTypes.array,
    rows: PropTypes.number,
    variant: PropTypes.string,
    validateRule: PropTypes.string,
    isInputFilled: PropTypes.func,
    handleOnFocus: PropTypes.func,
    handleOnKeyUp: PropTypes.func,
    inputType: PropTypes.string,
    max: PropTypes.number,
    setTextInputState: PropTypes.func,
    errorMessage: PropTypes.string,
    flagError: PropTypes.bool,
    returnFieldProps: PropTypes.func,
    silent: PropTypes.bool,
    // InputProps: PropTypes.object,
    inputProps: PropTypes.object,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    nativeSelect: PropTypes.bool,
    getBrand: PropTypes.object,
    autoComplete: PropTypes.string,
    customSelect: PropTypes.bool,
    customInput: PropTypes.bool,
    showIntputBox: PropTypes.bool,
    showDefaultDropDownValue: PropTypes.string,
    maskInput: PropTypes.string,
    startAdornment: PropTypes.string,
    track: PropTypes.func,
    redAsterisk: PropTypes.bool,
};

TextFieldWrapper.defaultProps = {
    id: '',
    val: '',
    inputType: null,
    select: null,
    required: null,
    label: '',
    className: null,
    dropdown: null,
    textarea: null,
    inputFieldType: 'text',
    rows: 0,
    max: 0,
    borderedSelect: false,
    borderedInput: false,
    errorMessage: null,
    validateRule: null,
    flagError: null,
    // InputProps: {},
    inputProps: {},
    variant: 'standard',
    placeholder: '',
    disabled: false,
    silent: false,
    nativeSelect: false,
    isInputFilled: () => { },
    setTextInputState: () => { },
    handleOnFocus: () => { },
    handleOnKeyUp: () => { },
    returnFieldProps: () => { },
    getBrand: null,
    autoComplete: 'off',
    customSelect: false,
    maskInput: '',
    customInput: false,
    infoHelpText: '',
    showIntputBox: false,
    showDefaultDropDownValue: '',
    startAdornment: null,
    track: () => { },
    redAsterisk: false,
};

const styledTextFieldWrapper = withStyles(styles)(TextFieldWrapper);
export default connect(mapStateToProps, mapDispatchToProps)(styledTextFieldWrapper);
